
// Prevent IE/Edge from executing transitions on load (makes the page load in a really weird way)

if (window.navigator.userAgent.indexOf('Edge') > -1 || document.documentMode) {
  const element = document.documentElement

  element.classList.add('is-loading')
  window.addEventListener('load', () => window.requestAnimationFrame(() => element.classList.remove('is-loading')))
}
